import { useMemo, useEffect, useState, useCallback } from 'react'

export default function useResponsiveDimensions(containerRef, watchElResize) {
  const [dimensions, setDimensions] = useState({ height: 0, width: 0 })

  const containerElement = containerRef?.current

  const updateDimensions = useCallback(() => {
    if (containerElement) {
      const { height, width } = containerElement.getBoundingClientRect()
      setDimensions({ height, width })
    }
  }, [containerElement])

  const resizeObserver = useMemo(() => {
    try {
      return new ResizeObserver(([{ contentRect: { height, width } }]) => {
        if (containerElement) setDimensions({ height, width })
      })
    } catch (e) {
      return undefined
    }
  }, [containerElement])

  useEffect(() => {
    window.addEventListener('resize', updateDimensions)
    if (watchElResize) resizeObserver?.observe(containerElement)
    return () => {
      window.removeEventListener('resize', updateDimensions)
      if (watchElResize && containerElement) resizeObserver?.unobserve(containerElement)
    }
  }, [containerElement])

  useEffect(() => {
    updateDimensions()
  }, [containerElement, updateDimensions])

  return dimensions
}
